import React, { FC, useCallback } from 'react'
import { useFormContext } from 'react-hook-form'
import { Button, Icon } from '@wmgtech/legato'
import { cn } from 'shared/utils'

import { ConditionRender } from 'components'
import { IStepperNavigationProps } from './StepperNavigation.props'
import './StepperNavigation.scss'

const StepperNavigation: FC<IStepperNavigationProps> = ({ hidden, onGoBack, onNext }) => {
  const { getValues, trigger, reset } = useFormContext()

  const onNextHandler = useCallback(async () => {
    const values = getValues()

    const isValid = await trigger()
    if (!isValid && values.step < 3) return

    if (onNext) onNext()
    if (values.step < 3) {
      reset({
        ...values,
        step: values.step + 1
      })
    }
  }, [getValues, onNext, trigger, reset])

  const onGoBackHandler = useCallback(() => {
    const values = getValues()

    if (onGoBack) onGoBack()
    if (values.step > 0) {
      reset({
        ...values,
        step: values.step - 1
      })
    }
  }, [getValues, onGoBack, reset])

  return (
    <div
      className={cn('stepper-navigation', {
        'stepper-navigation--hidden': hidden
      })}
    >
      <Button
        onClick={onGoBackHandler}
        containerStyle="outline"
        colorType="info"
        className="stepper-navigation__back-button"
        secondaryIcon={<Icon name="arrow-left" className="stepper-navigation__back-button-icon" />}
        label="Back"
      />
      <ConditionRender
        condition={!!onNext}
        component={
          <Button
            onClick={onNextHandler}
            containerStyle="solid"
            colorType="secondary-black"
            className="stepper-navigation__next-button"
            icon={<Icon name="arrow-right" className="stepper-navigation__next-button-icon" />}
          >
            Next
          </Button>
        }
      />
    </div>
  )
}

export default StepperNavigation
